import { Component, ContentChild, Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ButtonComponent } from '@syncfusion/ej2-angular-buttons';
import { GridComponent, RecordDoubleClickEventArgs } from '@syncfusion/ej2-angular-grids';
import { TextBoxComponent } from '@syncfusion/ej2-angular-inputs';
import { Dialog, DialogComponent } from '@syncfusion/ej2-angular-popups';
import { Subject } from 'rxjs';
import { ModalPesquisaService } from './modal-pesquisa.service';

@Directive({
  selector: '[appFiltroPesquisa]',
})
export class FiltroPesquisaDirective {
  constructor(public templateRef: TemplateRef<unknown>) { }
}

@Directive({
  selector: '[appConteudoPesquisa]',
})
export class ConteudoPesquisaDirective {
  constructor(public templateRef: TemplateRef<unknown>) { }
}

@Directive({
  selector: '[appGridPesquisa]',
})
export class GridPesquisaDirective {
  constructor(public grid: GridComponent) { }
}

@Directive({
  selector: '[appItemFocadoFiltroPesquisa]',
})
export class ItemFocadoFiltroPesquisaDirective {
  constructor(public item: TextBoxComponent) { }
}

@Directive({
  selector: '[appBotaoFocadoFiltroPesquisa]',
})
export class BotaoFocadoFiltroPesquisaDirective {
  constructor(public item: ButtonComponent) { }
}

@Component({
  selector: 'app-base-pesquisa',
  templateUrl: './base-pesquisa.component.html',
  styleUrls: ['./base-pesquisa.component.less']
})
export class BasePesquisaComponent implements OnInit {

  public estaEmTelaCheia: boolean = false;

  @ContentChild(FiltroPesquisaDirective)
  filtroDiretiva: FiltroPesquisaDirective | null = null;

  @ContentChild(ConteudoPesquisaDirective)
  conteudoDiretiva!: ConteudoPesquisaDirective;

  @ContentChild(ItemFocadoFiltroPesquisaDirective)
  itemFocadoDiretiva: ItemFocadoFiltroPesquisaDirective | null = null;

  @ContentChild(BotaoFocadoFiltroPesquisaDirective)
  botaoFocadoDiretiva: BotaoFocadoFiltroPesquisaDirective | null = null;

  private _gridDiretiva: GridPesquisaDirective | null = null;

  @ContentChild(GridPesquisaDirective)
  set gridDiretiva(valor: GridPesquisaDirective | null) {
    this._gridDiretiva = valor;
    if (!this._gridDiretiva?.grid)
      return;

    this._gridDiretiva.grid.recordDoubleClick.subscribe((args: RecordDoubleClickEventArgs) => {
      this.registroSelecionado.emit(args.rowData);
      this.fechar();
    });
  }

  get gridDiretiva(): GridPesquisaDirective | null {
    return this._gridDiretiva;
  }
  @ViewChild('mainContent', { static: false })
  content!: ElementRef<HTMLElement>;

  public contentHeight: string = '';

  @Output()
  public abriuModal: boolean = false;

  @Input()
  titulo: string = '-';

  @Input()
  largura: string = "98%";

  @Input()
  altura: string = "95%";

  @Input()
  iconCss: string = "fas fa-search";

  @Input()
  noActions: boolean = false;

  @Input()
  subtitulo: string = '-';

  @Input()
  id: string = 'base-pesquisa-' + Math.random() * 1000;

  @ViewChild('modal')
  modal!: DialogComponent;

  @Input()
  container: string = 'body';

  @Output()
  aberto: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  fechando: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  registroSelecionado: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  carregarDados: EventEmitter<void> = new EventEmitter<void>();

  constructor(private servico: ModalPesquisaService) {
    servico.setarComponenteBase(this);
  }

  okSubject: Subject<any> = new Subject<any>();

  ngOnInit() {

  }

  clickOk() {

    if (this.ok)
      this.ok();

    this.okSubject.next(true);

    if (this.gridDiretiva?.grid && this.gridDiretiva?.grid.getSelectedRecords().length > 0) {
      this.registroSelecionado.emit(this.gridDiretiva?.grid.getSelectedRecords()[0]);
      this.fechar();
    }
  }

  abrir() {
    this.modal.show(false);
  }

  abrirTelaCheia() {
    this.modal.show(true);
  }

  public opened() {
    /*if(this.grid === null)
      return;

    /*this.grid.height = 400;
    let minus: number = 0;
    let parent: Element = this.grid.element.parentElement;
    let nodes: NodeListOf<ChildNode> = this.grid.element.parentElement.childNodes

    var computedStyle: CSSStyleDeclaration = getComputedStyle(parent);

    let parentHeight: number = parent.clientHeight;  // height with padding
    let parenttWidth: number = parent.clientWidth;   // width with padding
    
    parentHeight -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
    parenttWidth -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);

    nodes.forEach((c: ChildNode) => {
      let el: Element = c as Element;
      if(c.nodeType === c.ELEMENT_NODE || c.nodeType === c.TEXT_NODE) {
        if(this.grid.element.id !== el.id) {
          if(el.clientHeight) {
            minus += el.clientHeight;
          }
        }
      }
    });

    // 42 header, 42 filter, 8 difernça manual
    this.grid.height = parentHeight - minus - 42 - 42 - 8;
    this.grid.refresh();*/


  }

  public alterarTelaCheia() {
    this.estaEmTelaCheia = !this.estaEmTelaCheia;
    this.modal.show(this.estaEmTelaCheia);
  }

  canShowContent: boolean = false;
  alreadyOpened: boolean = false;



  executarAntesDeAbrir() {
    this.contentHeight = this.content.nativeElement.clientHeight + '';

    this.itemFocadoDiretiva?.item.focusIn();
    this.botaoFocadoDiretiva?.item.focusIn();

    this.abriuModal = true;
    this.aberto.emit();
  }

  fechar() {
    if (this.cancel)
      this.cancel();

    this.modal.hide();
  }

  private ok: () => void = () => { };
  private cancel: () => void = () => { };

  openWithCallback(ok: () => void, cancel: () => void) {
    this.ok = ok;
    this.cancel = cancel;

    this.modal.show(false);
  }

  executarAntesDeFechar(ev: any) {
    this.fechando.next(ev);
  }

  tratarFechamento(dialog: DialogComponent) {
    console.log('tratarFechamento base pesquisa');

    if (this.gridDiretiva?.grid) {
      let grid = this.gridDiretiva.grid;

      grid.clearFiltering();
      grid.clearSorting();
      grid.clearSelection();
      grid.search('');

      if (grid.pageSettings)
        grid.pageSettings.currentPage = 1;
    }
  }

  @HostListener('document:visibilitychange', ['$event'])
  onVisibilityChanged(event: Event) {
    if (document.visibilityState === "visible" && this.modal.visible) {
      this.carregarDados.emit();
    }
  }
}
